import type { Stage } from '../../types';

export const pregnancy3: Stage = {
  id: 'pregnancy-3',
  key: '3',
  title: '妊娠後期',
  subtitle: '準備を整えて体を労わる',
  weeks: '28週〜',
  description: 'お腹が大きくなり、出産が近づきます。入院準備と産後のサポート網を固めましょう。',
  mindCards: [
    { id: 'm1', title: '準備で不安を小さく', body: 'リストを埋めていくことで、心の余裕を増やすことができます。', type: 'mind' },
    { id: 'm2', title: '体を労わる', body: '無理な立ち仕事や長時間の移動は避け、休息を優先しましょう。', type: 'body' },
    { id: 'm3', title: '陣痛・破水の見分け方', body: '連絡先とタイミングを確認し、慌てない備えをしましょう。', type: 'life' },
    { id: 'm4', title: '産後のサポートを手配', body: '家事・育児サポートを予約し、ママを守る体制を整えます。', type: 'mind' },
    { id: 'm5', title: '小児科を決める', body: '近所の小児科や夜間診療の体制を確認。急な発熱にも備えます。', type: 'life' },
    { id: 'm6', title: 'パートナーの役割を明確に', body: '立ち会い・家事・連絡役。具体的な役割を決めておきましょう。', type: 'partner' },
    { id: 'm7', title: '体重管理を最後まで', body: 'BMIに応じた推奨体重増加量を目安に、末期は+450kcal程度を意識しましょう。', type: 'body' },
    { id: 'm8', title: '授乳・搾乳のイメージ', body: '母乳・ミルクの併用も含め、焦らない準備をしましょう。', type: 'mind' },
  ],
  checklist: [
    { id: 'c1', text: '入院バッグを準備する', category: 'shopping', note: '母子手帳・保険証・着替え・衛生用品' },
    { id: 'c2', text: '産院の入院スケジュールを確認する', category: 'hospital', note: '入り方・持ち物・面会時間など' },
    { id: 'c3', text: '陣痛タクシー・連絡先を登録する', category: 'life', note: '夜間も対応している会社を確認' },
    { id: 'c4', text: '緊急連絡先を家族と共有する', category: 'admin', note: '産院・タクシー・実家など' },
    { id: 'c5', text: '新生児訪問健診の予約を確認する', category: 'hospital', note: '自治体からの訪問・1か月健診' },
    { id: 'c6', text: '産後ヘルプを手配する', category: 'life', note: '実家・ヘルパー・産後ケア事業' },
    { id: 'c7', text: 'ベビー用品の最後の買い足しをする', category: 'shopping', note: '必需品が揃っているか確認' },
    { id: 'c8', text: '出産費用の支払い準備をする', category: 'admin', note: '現金・カード・振込の対応を確認' },
    { id: 'c9', text: '出産育児一時金の申請手続きを確認する', category: 'admin', note: '産院経由の直接支払いか自己申請か' },
    { id: 'c10', text: '里帰り・移動の計画を立てる', category: 'admin', note: '交通手段と緊急時の対応' },
    { id: 'c11', text: '陣痛と破水の見分け方を確認する', category: 'body', note: '産院に連絡するタイミングを決める' },
    { id: 'c12', text: '父親の産休取得や立ち会いを確認する', category: 'partner', note: '産院のルールと会社の手続き' },
    { id: 'c13', text: '夜間の対応・連絡役を話す', category: 'partner', note: '陣痛が始まったら誰に連絡するか' },
    { id: 'c14', text: '胎動を観察し、異常を見逃さない', category: 'body', note: '胎動カードを活用' },
    { id: 'c15', text: '小児科を選び、診療時間を確認する', category: 'hospital', note: '夜間・休日対応も確認' },
    { id: 'c16', text: '出生届の書き方を確認する', category: 'admin', note: '出産後14日以内に提出' },
    { id: 'c17', text: 'ベビー服の洗濯を済ませる', category: 'life', note: '新生児肌着は中性洗剤で' },
    { id: 'c18', text: 'カーシートの取り付けを確認する', category: 'shopping', note: '退院時に使う準備を' },
    { id: 'c19', text: '産後の食事メニューを検討する', category: 'life', note: '作り置きや惣菜のリストを' },
    { id: 'c20', text: 'リラックスできる時間を確保する', category: 'mind', note: 'マッサージや音楽でリラックス' },
    { id: 'c21', text: 'パートナーと出産計画書を確認する', category: 'partner', note: '陣痛中の対応・立ち会いの有無' },
    { id: 'c22', text: '無痛分娩や分娩方法の希望を確認する', category: 'hospital', note: '産院の対応可否を確認' },
    { id: 'c23', text: '陣痛タクシーの登録・夜間対応を確認する', category: 'life', note: '早朝・深夜の対応、料金体系も確認' },
    { id: 'c24', text: '小児科の休日・夜間体制を確認する', category: 'hospital', note: 'かかりつけ小児科を早めに決めておく' },
    { id: 'c25', text: '父親の産休（出生時育児休業）を申請する', category: 'partner', note: '出産後8週間以内に4週間まで取得可能。会社へ2週間前まで申し出を。' },
    { id: 'c26', text: '妊婦支援給付金（2回目）の申請を確認する', category: 'admin', note: '出産予定日の8週間前の日等から2年以内。新潟市の例。' },
    { id: 'c27', text: '産後ケア事業の利用を申請する', category: 'admin', note: '新潟市の例。原則妊娠8か月から利用日の10日前まで。宿泊・デイ・訪問があります。' },
    { id: 'c28', text: '里帰り出産の場合の転出手続きを確認する', category: 'admin', note: '健康保険・住民票の移動が必要な場合があります' },
    { id: 'c29', text: '出産費用の支払い方法を産院に確認する', category: 'admin', note: '現金・カード・振込・直接支払い（出産育児一時金）など' },
    { id: 'c30', text: '入院準備リストを最終確認する', category: 'shopping', note: '産院ごとに持参不要のものがあるため、事前確認を' },
    { id: 'c31', text: '受動喫煙防止のルールを家庭で決める', category: 'life', note: '妊婦・乳幼児のそばでは絶対に禁煙' },
  ],
  shopping: [
    { id: 's1', name: '入院バッグ一式', priority: 'must', timing: '後期', priceYenMin: 5000, priceYenMax: 15000, note: '母子手帳・保険証・産褥パッド・前開きパジャマ・洗面用具など' },
    { id: 's2', name: '産褥ショーツ', priority: 'must', timing: '後期', priceYenMin: 2000, priceYenMax: 5000, note: '産後用の大きめサイズを3〜5枚' },
    { id: 's3', name: '母乳パッド', priority: 'must', timing: '後期', priceYenMin: 1000, priceYenMax: 3000, note: '使い捨てまたは布製' },
    { id: 's4', name: 'ベビー服（退院用含む）', priority: 'must', timing: '後期', priceYenMin: 3000, priceYenMax: 10000, note: '新生児サイズと50〜60cmを各4〜5枚程度用意' },
    { id: 's5', name: 'ベビー布団・ベビーベッド', priority: 'must', timing: '後期', priceYenMin: 15000, priceYenMax: 60000, note: '添い寝グッズかベッドかを選ぶ。レンタルも検討' },
    { id: 's6', name: '抱っこ紐', priority: 'should', timing: '後期〜産後', priceYenMin: 3000, priceYenMax: 15000, note: '新生児対応か確認' },
    { id: 's7', name: '授乳クッション', priority: 'should', timing: '後期〜産後', priceYenMin: 2000, priceYenMax: 6000, note: '授乳の腰の負担を軽減' },
    { id: 's8', name: 'チャイルドシート（0歳児対応）', priority: 'must', timing: '後期', priceYenMin: 20000, priceYenMax: 50000, note: '退院時に必要。取り付けも確認' },
    { id: 's9', name: 'おむつ新生児サイズ（大量）', priority: 'must', timing: '後期', priceYenMin: 4000, priceYenMax: 12000, note: '1日10枚以上使うことを想定' },
    { id: 's10', name: 'おしり拭き', priority: 'must', timing: '後期', priceYenMin: 1000, priceYenMax: 3000, note: '新生児用の低刺激タイプ' },
    { id: 's11', name: '哺乳瓶・乳首セット', priority: 'should', timing: '後期〜産後', priceYenMin: 2000, priceYenMax: 6000, note: '母乳・ミルク両方の準備に' },
    { id: 's12', name: 'ベビー用体温計', priority: 'should', timing: '後期', priceYenMin: 2000, priceYenMax: 5000, note: '耳・非接触・脇などタイプを選ぶ' },
    { id: 's13', name: '授乳用ブラジャー（入院用含む）', priority: 'must', timing: '後期', priceYenMin: 2000, priceYenMax: 6000, note: '前開き・楽な着け心地を優先' },
    { id: 's14', name: '産褥パッド・お産パッド', priority: 'must', timing: '後期', priceYenMin: 1500, priceYenMax: 5000, note: '入院中から産後2〜3週間分' },
    { id: 's15', name: '陣痛タクシー登録（費用目安）', priority: 'should', timing: '後期', priceYenMin: 0, priceYenMax: 5000, note: '自治体やタクシー会社により異なる。事前登録が必要な場合も' },
  ],
  warnings: [
    { id: 'w1', label: '破水', level: 'urgent' },
    { id: 'w2', label: '出血', level: 'urgent' },
    { id: 'w3', label: '陣痛', level: 'urgent' },
    { id: 'w4', label: '激しい頭痛・視界がぼける', level: 'urgent' },
    { id: 'w5', label: '意識がもうろうとする', level: 'urgent' },
    { id: 'w6', label: '胎動の減少', level: 'watch' },
    { id: 'w7', label: '足のむくみ', level: 'watch' },
    { id: 'w8', label: '手のしびれ', level: 'watch' },
    { id: 'w9', label: '睡眠が取れない', level: 'watch' },
    { id: 'w10', label: '嘔吐や下痢が続く', level: 'watch' },
    { id: 'w11', label: '胎動の極端な減少', level: 'watch' },
    { id: 'w12', label: '手や顔のむくみの急増', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '入院バッグの中身を確認する' , detail: '入院バッグの中身リストを一緒に確認し、置き場所を共有。母子手帳・保険証はすぐ出せる位置に。'},
    { id: 'p2', text: '陣痛時の連絡役を決める' , detail: '陣痛時の第一連絡者・タクシー・実家への連絡順を紙とスマホに残す。'},
    { id: 'p3', text: '産後の家事・育児分担を最終確認する' , detail: '産後2週間の家事・夜間役割を最終確認。完璧より「最低限これ」を決める。'},
    { id: 'p4', text: 'カーシートの取り付けを確認する' , detail: 'チャイルドシートを車に取り付け、退院日までに動作確認。取説をスマホに保存。'},
    { id: 'p5', text: '小児科の候補を一緒に調べる' , detail: 'かかりつけ小児科と休日・夜間の候補をリスト化。電話番号を共有メモへ。'},
    { id: 'p6', text: '出産計画書の希望を確認する' , detail: '出産計画書の希望（立ち会い・鎮痛など）を一緒に読み、変更もあり得ると確認。'},
    { id: 'p7', text: '里帰り時の交通手段を確認する' , detail: '里帰りするなら交通手段・荷物・産後ケアの申し込み期限を確認（新潟市の産後ケアは早め申請）。'},
    { id: 'p8', text: 'ママの休息を優先する声かけをする' , detail: '「休んで」だけでなく、代わりにやる家事を先に宣言する。'},
    { id: 'p9', text: '産後パパ育休の取得を会社へ申し出る' , detail: '産後パパ育休（出生時育児休業）の取得意向を会社へ。開始2週間前までの申し出が目安。'},
  ],
  tips: [
    { id: 't1', title: '入院バッグは34〜36週までに完成', body: '急な入院も想定して、母子手帳・保険証・産褥パッド・着替えをまとめておくと安心。パートナーにも中身を見せておくとよい。' },
    { id: 't2', title: '陣痛タクシーは登録だけで安心', body: '夜間や早朝の対応を確認し、連絡先をスマホに登録。使わなくても、あると心が楽になります。' },
    { id: 't3', title: '胎動は「減ったら」すぐ連絡', body: '胎動が普段より明らかに減ったら、産院へ連絡。恥ずかしがらずに、すぐ相談することが大切です。' },
    { id: 't4', title: '産後の家事は「完璧」にしない', body: '掃除や洗濯は最低限に。食事は惣菜や作り置きを活用。産後はママの回復が最優先です。' },
    { id: 't5', title: '小児科は休日・夜間体制も確認', body: '急な発熱に備え、かかりつけ小児科と、休日・夜間に受診できる病院のリストを作っておきましょう。' },
    { id: 't6', title: '里帰り出産は手続きを忘れずに', body: '実家のある自治体で出産や健診を受ける場合、健康保険・住民票の手続きが必要な場合があります。' },
    { id: 't7', title: '産後ケアは妊娠8か月から申請', body: '新潟市の産後ケア事業は宿泊型・デイ型・訪問型があります。利用日の10日前までに申請が必要なので早めに。' },
    { id: 't8', title: '受動喫煙防止を徹底', body: '妊婦や乳幼児のそばではたばこを吸わないルールを。換気扇下でも副流煙は防げません。' },
  ],
  adminGuide: [
    { id: 'a1', title: '出生届の提出', body: '赤ちゃんの出生から14日以内に、父または母の本籍地・住所地の市区町村へ提出。必要書類は産院から交付されます。', when: '出産後14日以内' },
    { id: 'a2', title: '出産育児一時金の請求', body: '健康保険に加入していれば、出産1件ごとに給付されます。産院経由で直接支払いに充当するか、事後請求も可能です。', when: '出産時または出産後' },
    { id: 'a3', title: '児童手当・乳児医療証', body: '出生届提出後、児童手当や乳児医療費助成の申請案内が届きます。手続き期限を守りましょう。', when: '出生届提出後' },
    { id: 'a4', title: '産後ケア事業の予約', body: '自治体や産院が産後の宿泊型・訪問型ケアを提供。産後の休息と育児支援を受けられます。新潟市の例。', when: '妊娠後期〜出産直後' },
    { id: 'a5', title: '父親の産休取得', body: '出産後8週間以内の「出生時育児休業」が取得できます。雇用保険から給付金が支給されます。会社へ事前に申請を。', when: '妊娠後期に会社へ申請' },
    { id: 'a6', title: '里帰り出産の転出手続き', body: '実家のある自治体で出産や健診を受ける場合、健康保険の手続きや住民票の移動が必要な場合があります。事前に確認を。', when: '出産前に調整' },
    { id: 'a7', title: '妊婦支援給付金（2回目）', body: '新潟市で出産した産婦を対象。出産予定日の8週間前の日等から2年以内に電子申請します。', when: '出産前後' },
    { id: 'a8', title: '産後ケア事業の利用申請', body: '新潟市では宿泊型・デイ型・訪問型があります。原則妊娠8か月から利用日の10日前までに申請が必要です。', when: '妊娠後期' },
    { id: 'a9', title: '国民健康保険・国民年金の産前産後免除', body: '産前産後期間の保険料が免除・軽減されます。年金受給額は減りません。出産予定日の6か月前から届出可能です。', when: '妊娠後期〜出産後' },
    { id: 'a10', title: '子ども医療電話相談事業（#8000）', body: '新潟市などで、休日・夜間に子どもの病気やけがで迷った際に看護師等へ相談できます。自治体により異なります。', when: 'いつでも覚えておく' },
  ],
  exercises: [
    {
      id: 'ex1',
      title: '妊娠全期向けワークアウト（15分）',
      durationMin: 15,
      url: 'https://www.youtube.com/watch?v=zmUJWKM98hM',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '後期は特にお腹の張りに注意。無理せず、休憩を多めに取りましょう。',
      level: 'gentle',
    },
    {
      id: 'ex2',
      title: '妊婦ヨガフロー（20分）',
      durationMin: 20,
      url: 'https://www.youtube.com/watch?v=feHp2b29G5U',
      channel: '妊娠・産後エクササイズチャンネル',
      note: 'ゆったりしたフローで、股関節まわりをほぐします。',
      level: 'gentle',
    },
    {
      id: 'ex3',
      title: 'アドリエンの妊婦ヨガ',
      durationMin: 22,
      url: 'https://www.youtube.com/watch?v=-3bvlFKeLRE',
      channel: 'アドリエンのヨガ',
      note: '深い呼吸でリラックス。出産に向けて心を整えましょう。',
      level: 'gentle',
    },
  ],
};
